import { render, staticRenderFns } from "./ReceivingCloseDetail.vue?vue&type=template&id=c6dad356"
import script from "./ReceivingCloseDetail.vue?vue&type=script&lang=js"
export * from "./ReceivingCloseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports